import React, { useEffect, Fragment, useState, useMemo } from "react";
import { NavLink } from "react-router-dom";
import Moment from "react-moment";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Accordion from "react-bootstrap/Accordion";
import { FaStar } from "react-icons/fa";
import cx from "../Portal.module.css";
import { BiSolidDownArrow } from "react-icons/bi";
// import "./clients.css";
import { taskImages } from "../../constants/roles";
import {
  convertTimeToUserTimeZone,
  convertToTimeZone,
  getFullName,
} from "../../utils/CommonFunctions";
import { httpPortal } from "../../Apis/commonApis";
import { ShowSwal } from "../../utils/alertSwal";
import { wCategories } from "../../constants/constants";
import { BasicButton } from "../../admin/Clients/PublishDataTable";
import ImagePreviewModal from "../../components/ImagePreviewModal";

const ratingArr = [
  { star: 1 },
  { star: 2 },
  { star: 3 },
  { star: 4 },
  { star: 5 },
];

const JournalDetails = (props) => {
  let { clientJournal, setRefreshData, clientData } = props;

  const [rating, setRating] = useState(0);

  useEffect(() => {
    setRating(clientJournal?.fndfRating);
  }, [clientJournal]);

  const filteredNotes = useMemo(() => {
    const filterByClientAndShift = clientJournal.notesData?.filter(
      (item) =>
        item?.clientId === clientJournal?.clientId?.[0] &&
        item.shiftId === clientJournal.shiftId
    );
    const familyNotes = filterByClientAndShift?.filter(
      (item) => item?.notesType === "family"
    );
    const cateteamNotes = filterByClientAndShift?.filter(
      (item) => item?.notesType === "careteammember"
    );
    return { familyNotes, cateteamNotes };
  }, [clientJournal]);

  function completedTasks(journalData) {
    let tasks = journalData?.Task;
    let completed = tasks?.filter(
      (item) => item?.status === "true" && item.shiftId === journalData.shiftId
    );
    return [
      completed?.length ? completed?.length : 0,
      tasks?.length ? tasks?.length : 0,
    ];
  }

  const giveRating = async () => {
    if (rating === 0) return;
    let body = {
      careHomeId: clientData?.careHomeId,
      shiftId: clientJournal?.shiftId,
      clientId: clientData?._id,
      rating: rating,
    };
    const res = await httpPortal(`giveRating`, "post", body, "json");
    setRefreshData(Math.random());
    ShowSwal(res.status, res.message);
  };

  function handleStarClick(value) {
    if (value === 1 && value === rating) {
      setRating(0);
    } else {
      setRating(value);
    }
  }

  const filteredTasks = useMemo(() => {
    return clientJournal?.Task.filter(
      (task) =>
        (task?.status === "omitted" || task?.status === "true") &&
        task.shiftId === clientJournal.shiftId
    ).sort((a, b) => {
      if (a.taskType === "wellbeing" && b.taskType !== "wellbeing") return -1;
      if (a.taskType !== "wellbeing" && b.taskType === "wellbeing") return 1;
      return 0;
    });
  }, [clientJournal]);

  const isCareNoteDisplay = clientData?.setting?.careNoteDisplay;

  const [openPreview, setOpenPreview] = useState("");

  return (
    <>
      <ImagePreviewModal
        openModal={openPreview !== ""}
        handleClose={() => setOpenPreview("")}
        image={openPreview}
      />

      <div
        className={`col-md-6 tabbingMenu journalListScroll mb-3 mb-md-2 mb-lg-2 mb-xl-2 ${cx.clientNotesBox}`}
      >
        <div className={`tabbingMenu journalListScroll ${cx.clientNotesBox}`}>
          <div className={`${cx.rightShift}`}>
            <ul className="menuList">
              <li>
                <NavLink to="#">
                  <img
                    alt="careteam-profile"
                    src={clientData?.image ?? "/admin/images/chatUser.svg"}
                  />
                  <div className="body">
                    <p>
                      {clientJournal?.startingTime} -{" "}
                      {clientJournal?.endingTime}{" "}
                    </p>
                    <h5>{getFullName(clientData)}</h5>

                    <p className="timeBox">
                      <span className="ms-3">
                        <Moment format="Do MMM YYYY">
                          {clientJournal?.Date}
                        </Moment>
                      </span>{" "}
                    </p>
                  </div>
                </NavLink>
              </li>
            </ul>
            <div className={cx.starList}>
              {ratingArr.map((item, index) => {
                return (
                  <button
                    key={item.star}
                    disabled={clientJournal?.fndfRating > 0}
                    onClick={() => handleStarClick(item.star)}
                    className={`${cx.stars} ${
                      item.star <= rating ? cx.active : ""
                    }`}
                  >
                    <FaStar />
                  </button>
                );
              })}
              {clientJournal?.fndfRating === 0 && (
                <button
                  className={cx.rateBtn}
                  onClick={giveRating}
                  type="button"
                >
                  Rate
                </button>
              )}
            </div>
          </div>
          <Tab.Container
            id="left-tabs-example"
            defaultActiveKey="taB1"
            className="justify-content-between"
          >
            <Nav variant="pills">
              <Nav.Item style={{ width: isCareNoteDisplay ? "30%" : "48%" }}>
                <Nav.Link eventKey="taB1">Tasks</Nav.Link>
              </Nav.Item>
              {isCareNoteDisplay && (
                <Nav.Item style={{ width: "35%" }}>
                  <Nav.Link eventKey="taB2">Care Notes</Nav.Link>
                </Nav.Item>
              )}
              <Nav.Item style={{ width: isCareNoteDisplay ? "35%" : "48%" }}>
                <Nav.Link eventKey="taB3">Family Notes</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="taB1">
                <ul className={`TasksList ${cx.tasklist}`}>
                  <p style={{ color: "#BB6BD9" }}>
                    {completedTasks(clientJournal)[0]} of{" "}
                    {completedTasks(clientJournal)[1]} Tasks Completed
                  </p>
                  {filteredTasks?.map((task, tIndex) => {
                    const globalTask = task.globalTask;
                    const taskDoneBy = getFullName(task.doneBy);
                    const conditionsToShowMed =
                      globalTask?.medName &&
                      globalTask?.prn?.toLowerCase() === "no";
                    const conditionsToShowPrn =
                      globalTask?.medName &&
                      globalTask?.prn?.toLowerCase() === "yes";

                    let taskStartTime = "00:00";
                    let taskEndTime = "23:59";
                    if (globalTask?.shiftType?.includes("specific")) {
                      taskStartTime = `${
                        convertTimeToUserTimeZone(
                          globalTask?.startTime,
                          clientJournal?.shiftTimeZone
                        ) ?? "--"
                      }`;
                      taskEndTime = `${
                        convertTimeToUserTimeZone(
                          globalTask?.endTime,
                          clientJournal?.shiftTimeZone
                        ) ?? "--"
                      }`;
                    }

                    if (conditionsToShowMed) {
                      return (
                        <li key={tIndex}>
                          <div className="listRow justify-content-between">
                            <p>
                              <img alt="dd" src={`/admin/images/s10.svg`} />
                              Medication Reminder
                            </p>
                            <p className={`teamNameInNotes me-5`}>
                              {`${taskStartTime} - ${taskEndTime}`}
                            </p>
                            <img
                              src={
                                task?.status === "true"
                                  ? "/admin/images/checkedIco.svg"
                                  : "/admin/images/crossIco.svg"
                              }
                              className="boxIcons"
                            />
                          </div>
                          <p>{globalTask?.NM}</p>
                          <p>
                            Dose: {globalTask?.doseAmount}{" "}
                            {globalTask?.UDFS_UOMCD}
                          </p>
                          <p>Dose Route: {globalTask?.adminRoute}</p>
                          <p>
                            Meal Consideration: {globalTask?.mealConsideration}
                          </p>
                          {task?.comments && (
                            <p>Description / Observations: {task?.comments}</p>
                          )}
                          {task?.reason && task?.status === "omitted" && (
                            <p>{`Reason: ${task?.reason}`}</p>
                          )}
                          <p className={`teamNameInNotes`}>
                            {taskDoneBy} ({convertToTimeZone(task?.timestamp)})
                          </p>
                        </li>
                      );
                    }
                    if (conditionsToShowPrn) {
                      return (
                        <li key={tIndex}>
                          <div className="listRow justify-content-between">
                            <p>
                              <img alt="rr" src={`/admin/images/s6.svg`} />
                              PRN Med
                            </p>
                            <img
                              src={
                                task?.status === "true"
                                  ? "/admin/images/checkedIco.svg"
                                  : "/admin/images/crossIco.svg"
                              }
                              className="boxIcons"
                            />
                          </div>
                          <p>{globalTask?.NM}</p>
                          <p>
                            Dose: {globalTask?.doseAmount}{" "}
                            {globalTask?.UDFS_UOMCD}
                          </p>
                          <p>Dose Route: {globalTask?.adminRoute}</p>
                          <p>
                            Meal Consideration: {globalTask?.mealConsideration}
                          </p>
                          {Object.keys(task).includes("comments") &&
                            task?.comments && (
                              <p>
                                Description / Observations: {task?.comments}
                              </p>
                            )}{" "}
                          {task?.reason && task?.status === "omitted" && (
                            <p>{`Reason: ${task?.reason}`}</p>
                          )}
                          <p className={`teamNameInNotes`}>
                            {taskDoneBy} ({convertToTimeZone(task?.timestamp)})
                          </p>
                        </li>
                      );
                    }
                    const taskImgObj = taskImages.find((elem) =>
                      globalTask?.taskName?.includes(elem?.Ctg)
                    );
                    let mesuredValue = "";
                    if (globalTask?.taskType === "BP") {
                      mesuredValue = task.input
                        ? ` ${task.input?.Systolic_BP?.measureValue}/${task.input?.Diastolic_BP?.measureValue} ${task.input?.Diastolic_BP?.measureType}`
                        : "";
                    } else {
                      mesuredValue =
                        task.input && task.input?.measureValue !== ""
                          ? `: ${task.input?.measureValue} ${task.input?.measureType}`
                          : "";
                    }
                    const isWellbeing =
                      task.taskCategory === "wellbeing" ||
                      task?.taskType === "wellbeing";
                    return (
                      <>
                        {isWellbeing ? (
                          <Fragment key={tIndex}>
                            <li>
                              <div className="listRow">
                                <img src="/admin/images/s9.svg" />
                                Wellbeing Assessment
                                <img
                                  src={
                                    task?.status === "omitted"
                                      ? "/admin/images/crossIco.svg"
                                      : "/admin/images/checkedIco.svg"
                                  }
                                  className="boxIcons"
                                />
                              </div>
                            </li>
                            <Accordion className="colorIcon">
                              <Accordion.Item eventKey="0">
                                <Accordion.Header
                                  style={{ borderBottom: "none" }}
                                >
                                  <BiSolidDownArrow />
                                </Accordion.Header>
                                <Accordion.Body>
                                  <ul>
                                    {wCategories?.map((wellCat, index) => {
                                      const ratingCount = [1, 2, 3, 4, 5, 6];
                                      const rating = task?.[wellCat.wCat] ?? 0;
                                      return (
                                        <li key={index}>
                                          <label>{wellCat.displayName}</label>
                                          <div>
                                            {ratingCount.map((count) => (
                                              <button key={count}>
                                                <img
                                                  className={
                                                    rating === count
                                                      ? "wellbineColor"
                                                      : ""
                                                  }
                                                  src={`/admin/images/is${count}.svg`}
                                                />
                                              </button>
                                            ))}
                                          </div>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                            {task?.reason && task?.status === "omitted" && (
                              <p className="mt-1">{`Reason: ${task?.reason}`}</p>
                            )}
                            <p className={`teamNameInNotes`}>
                              {taskDoneBy} ({convertToTimeZone(task?.timestamp)}
                              )
                            </p>
                          </Fragment>
                        ) : (
                          <li key={tIndex}>
                            <div className="listRow justify-content-between">
                              <p>
                                <img alt="icon" src={taskImgObj?.image} />
                                {task?.taskName}
                              </p>
                              <p className={`teamNameInNotes me-5`}>
                                {`${taskStartTime} - ${taskEndTime}`}
                              </p>
                              <img
                                src={
                                  task?.status === "omitted"
                                    ? "/admin/images/crossIco.svg"
                                    : "/admin/images/checkedIco.svg"
                                }
                                className="boxIcons"
                              />
                            </div>
                            <p>
                              {globalTask?.taskType}: {mesuredValue}
                            </p>
                            <p>Description / Observations: {task?.comments}</p>
                            {task?.reason && task?.status === "omitted" && (
                              <p>{`Reason: ${task?.reason}`}</p>
                            )}
                            <p className={`teamNameInNotes`}>
                              {taskDoneBy} ({convertToTimeZone(task?.timestamp)}
                              )
                            </p>
                          </li>
                        )}
                      </>
                    );
                  })}
                </ul>
              </Tab.Pane>
              <Tab.Pane eventKey="taB2">
                {filteredNotes?.cateteamNotes?.map((elem) => (
                  <div className="rightTextTabs" key={elem._id}>
                    {elem.media && (
                      <BasicButton onClick={() => setOpenPreview(elem.media)}>
                        <img src={elem.media} />
                      </BasicButton>
                    )}
                    <p>{elem.notesData}</p>
                    <p>
                      {getFullName(elem.careTeamId)} (
                      {convertToTimeZone(elem.createdAt)})
                    </p>
                  </div>
                ))}
                {filteredNotes?.cateteamNotes?.length < 1 && (
                  <p>No data available</p>
                )}
              </Tab.Pane>
              <Tab.Pane eventKey="taB3">
                {filteredNotes?.familyNotes?.map((elem) => {
                  return (
                    <div className="rightTextTabs" key={elem._id}>
                      {elem.media && (
                        <BasicButton onClick={() => setOpenPreview(elem.media)}>
                          <img src={elem.media} />
                        </BasicButton>
                      )}
                      <p>{elem.notesData}</p>
                      <p>
                        {getFullName(elem.careTeamId)} (
                        {convertToTimeZone(elem.createdAt)})
                      </p>
                    </div>
                  );
                })}
                {filteredNotes?.familyNotes?.length < 1 && (
                  <p>No data available</p>
                )}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </>
  );
};

export default JournalDetails;
